export function arrayEquals(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false
  }
  if (arr1.length != arr2.length) {
    return false
  }
  for (var item of arr1) {
    if (!arr2.includes(item)) {
      return false
    }
  }
  return true
}

/**
 * 一维数组转树形结构
 * @param {Array} rows 一维数组
 * @param {String} pid 父级id
 * @returns {Array} 树形结构
 */
export function deepTreeData(rows, pid) {
  var ret = []
  if (Array.isArray(rows)) {
    for (var row of rows) {
      if (row.pid == pid) {
        var item = Object.assign({ label: row.name, value: row.id }, row)
        var children = deepTreeData(rows, item.id)
        if (children && children.length > 0) {
          item.children = children
        }
        ret.push(item)
      }
    }
  }
  return ret
}

export function getIdsData(rows, prop) {
  var ids = []
  if (Array.isArray(rows)) {
    for (var row of rows) {
      ids.push(row[prop])
    }
  }
  return ids
}

/**
 * 遍历树形结构
 * @param {Array} rows 树形结构
 * @param {Function} callback 回调函数
 * @returns {Array} 返回值
 */
export function foreachTreeItem(rows, callback) {
  for (var row of rows) {
    var ret = callback(row, rows)
    if (ret) {
      return ret
    } else if (Array.isArray(row.children)) {
      ret = foreachTreeItem(row.children, callback)
      if (ret) {
        return ret
      }
    }
  }
}

/**
 * 获取资源树名称
 * @param {Array} allResourceData 所有资源数据
 * @param {String} id 资源id
 * @param {Array} result 结果
 */
export function deepGetResTreeName(allResourceData, id, result) {
  var found = allResourceData.find((item) => item.id == id)
  if (found) {
    var name = found.name
    if (found.res_type == 'rel' && found.use_rel_name) {
      name = found.rel_name
    }
    result.push(name)
    if (found.pid && found.pid != '0') {
      deepGetResTreeName(allResourceData, found.pid, result)
    }
  }
}

/**
 * 获取资源类型图标
 * @param {String} resType 资源类型
 * @param {String} meunPath 菜单路径
 * @returns {String} 图标
 */
export function getResTypeIcon(resType, meunPath) {
  if (resType == 'rel') {
    return 'el-icon-link'
  } else if (resType == 'normal') {
    return 'el-icon-s-operation'
  } else if (resType == 'menu') {
    return meunPath ? 'el-icon-document' : 'el-icon-menu'
  }
  return ''
}

/**
 * 获取资源类型图标
 * @param {Object} item 资源对象
 * @returns {Array<String>} 图标
 */
export function getMenuIcons(item) {
  var icons = []
  if (item.res_type == 'rel') {
    icons.push(getResTypeIcon(item.res_type))
    icons.push(getResTypeIcon(item.rel_res_type, item.rel_meun_path))
  } else {
    icons.push(getResTypeIcon(item.res_type, item.meun_path))
  }
  return icons
}

/**
 * 判断资源是否禁用
 * @param {Object} item 资源对象
 * @param {String} currentEnvironment 当前环境
 * @returns {Boolean} 是否禁用
 */
export function isInactive(item, currentEnvironment) {
  if (!item.active_envs) {
    return false
  }
  return item.active_envs.includes(currentEnvironment) ? false : true
}
